module.exports = __webpack_public_path__ + "static/images/poi.1L0ZmKz.svg";